<template>
  <div class="google-map">
    <input id="location-input" />
    <div id="gmp-map"></div>
  </div>
</template>

<script lang="ts">
/// <reference types="google.maps" />

import Vue from 'vue';
import { GoogleConfiguration } from '@/helpers/Constants';

 type RenderAddress = (                                                                                                                                                                                                                                           
     location?: google.maps.LatLng | google.maps.LatLngLiteral                                                                                                                                                                                                      
   ) => void;     

export default Vue.extend({
  name: "google-map",
  computed: {
    geoLocation() {
      return this.$store.state.geoLocation;
    },
  },
  watch: {
    geoLocation(place) {
      this.renderAddress && this.renderAddress(place?.geometry?.location);
    }
  },
  data(): { renderAddress: RenderAddress | null } {  
    return {
      renderAddress: null
    };
  },
  mounted() {
    const that = this;
    window.initMap = function() {
      const getFormInputElement = (component: string): HTMLInputElement => {
        const result = document.getElementById(component + '-input');
        if (!result) {
          throw new Error(`Element with id ${component}-input not found`);
        }
        return result as HTMLInputElement;
      }
      const mapElement = document.getElementById('gmp-map');
      if (!mapElement) {
        console.error('Map element not found');
        return;
      }
      /* eslint-disable no-undef */
      const map = new google.maps.Map(mapElement, {
        zoom: GoogleConfiguration.mapOptions.zoom,
        center: GoogleConfiguration.mapOptions.center,
        mapTypeControl: false,
        fullscreenControl: true,
        zoomControl: true,
        streetViewControl: false,
        mapId: GoogleConfiguration.mapOptions.mapId || 'PROCON_MAP_ID',
      });
      const marker = new google.maps.marker.AdvancedMarkerElement({ map: map });
      const autocompleteInput = getFormInputElement('location');
      const autocomplete = new google.maps.places.Autocomplete(autocompleteInput, {
        fields: ["geometry", "name"],
        types: ["address"],
      });
      /* eslint-enable no-undef */
      autocomplete.addListener('place_changed', function() {
        // @ts-ignore-next-line
        marker.visible = false;
        const place = autocomplete.getPlace();
        if (!place.geometry) {
          // User entered the name of a Place that was not suggested and pressed the Enter key, or the Place Details request failed.
          window.alert('No details available for input: \'' + place.name + '\'');
          return;
        }
        that.$store.commit('geoLocation', place);
      });

      that.renderAddress = function renderAddress(
        location?: google.maps.LatLng | google.maps.LatLngLiteral
      ): void {
        try {
          map.setCenter(location || GoogleConfiguration.mapOptions.center);
          map.setZoom(GoogleConfiguration.mapOptions.zoom);
          marker.position = location;
          // @ts-ignore-next-line
          marker.visible = true;
        } catch (error) {
          console.error(error);
        }
      };

      console.log('Google Map script loaded');
    };

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GoogleConfiguration.mapsApiKey}&libraries=places,marker&callback=initMap&loading=async`;
    document.head.appendChild(script);
  }
});
</script>

<style lang="scss">
  .google-map {
    display: none;
  }
</style>
